<div>
    <div class="d-flex flex-row justify-content-end">
        <button class="btn btn-warning mr-1" (click)="onCancelClick()" *ngIf="_isEditing">Cancel</button>
        <button class="btn btn-secondary mr-1" (click)="onEditClick()" *ngIf="!_isEditing">Edit</button>
        <button class="btn btn-secondary" [disabled]="!_isEditing||taskForm.pristine" (click)="saveData()">Save</button>
    </div>
</div>
<div class="pt-2">
    <form id="editForm" [formGroup]="taskForm" class="m">
        <ng-container *ngFor="let group of forms">
            <span class="gray font-italic pl-2">{{group.title}}</span>
            <a id="copyPrevious" *ngIf="_isEditing && previousSeq?.data?.timestamp" href="javascript:false;" 
                    (click)="fillWithPrevious(group)" class="text-nowrap mx-1">
                Copy From Previous
            </a>
            <table class="table table-striped table-bordered table-sm">
                <tbody>
                    <tr *ngFor="let form of group.forms">
                        <th class="text-nowrap">{{form.label}}</th>
                        <td>
                            <ng-container [ngSwitch]="form.controlType">
                                <input *ngSwitchCase="'textbox'" [formControlName]="form.key" [id]="form.key"
                                    [type]="form.type" class="form-control" onmousewheel="this.blur()">

                                <select [id]="form.key" *ngSwitchCase="'dropdown'" [formControlName]="form.key"
                                    class="form-control">
                                    <option *ngFor="let opt of form.options" [value]="opt.key">{{opt.value}}</option>
                                </select>
                            </ng-container>
                        </td>
                    </tr>
                </tbody>
            </table>
        </ng-container>
    </form>
    <div *ngIf="seq?.data?.timestamp" class="small text-secondary font-italic pl-1">
        Saved at {{seq?.data?.timestamp|date:'yyyy-MM-dd HH:mm:ss'}} (Local)
        <span *ngIf="userName$ | async as userName">
            by {{userName}}
        </span>
    </div>
</div>